import React, { Component } from "react";
import "./style.scss";
import {
  NormalButton,
  TableWrapper,
  NormalModal,
  NormalInput,
  NormalDate,
} from "component/common";
import { FormGroup, Label, Input } from "reactstrap";
import {
  getCommonApi,
  updateForm,
  commonCreateApi,
  commonDeleteApi,
  commonPatchApi,
} from "redux/actions/common";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PDFViewer, PDFDownloadLink, BlobProvider } from "@react-pdf/renderer";
import Invoice from "component/Admin/Report/Account/Invoice";

import closeIcon from "assets/images/close.png";
import { withTranslation } from "react-i18next";
import { dateFormat } from "service/helperFunctions";
import { Toast } from "service/toast";
import shareIcon from "assets/images/shareicon.png";
import { ShareModal } from "component/Admin/Cart/sharePackage";

export class PrepaidAccountClass extends Component {
  state = {
    activeTab: "",
    isOpenTreatmentDone: false,
    isActiveTab: "detail",
    isOpenExpiryDate: false,
    editExpiryDate: "",
    editPrepaidId: "",
    terminatePrepaidPrepaidId: "",
    customerDisplayFlag: false,
    headerDetails: [
      { label: "", sortKey: false, width: "90px" },
      { label: "", sortKey: false, width: "180px" },
      { label: "", sortKey: false, width: "40px" },
      {
        label: "Purchase Date",
        sortKey: false,
        width: "130px",
        // divClass: "justify-content-end text-right",
      },
      { label: "Invoice", sortKey: false, width: "120px" },
      { label: "Transaction", sortKey: false, width: "120px" },
      { label: "Prepaid Description", width: "242px" },
      {
        label: "Last Update",
        sortKey: false,
        width: "120px",
        divClass: "justify-content-end text-right",
      },

      { label: "Type", sortKey: false, width: "120px" },
      {
        label: "Expiry Date",
        sortKey: false,
        width: "110px",
        divClass: "justify-content-end text-right",
      },
      { label: "Expiry Status", sortKey: false, width: "120px" },
      {
        label: "Payment",
        sortKey: false,
        width: "100px",
        divClass: "justify-content-end text-right",
      },
      {
        label: "Balance",
        sortKey: false,
        width: "72px",
        divClass: "justify-content-end text-right",
      },
    ],
    detailHeader: [
      { label: "Date", sortKey: false, width: "150px" },
      { label: "Prepaid Ref", sortKey: false, width: "150px" },
      { label: "Transaction Ref", sortKey: false, width: "225px" },
      { label: "Status", sortKey: false, width: "150px" },
      // { label: "Voucher #", width: "100px" },
      // { label: "Item No", sortKey: false, width: "70px" },
      { label: "Item Name", sortKey: false, width: "72px" },
      {
        label: "Payment",
        sortKey: false,
        width: "72px",
        // divClass: "justify-content-end text-right",
      },
      {
        label: "Used Amt",
        sortKey: false,
        width: "72px",
        // divClass: "justify-content-end text-right",
      },

      {
        label: "Balance",
        sortKey: false,
        width: "72px",
        // divClass: "justify-content-end text-right",
      },
      // {
      //   label: "Topup #",
      //   sortKey: false,
      //   width: "72px",
      //   divClass: "justify-content-end text-right",
      // },
    ],
    accountList: [],
    accountHeader: {},
    show: "active",
    DetailList: [],
    isPrintPdfClick: false,
    prepaidPopupUserName: "",
    prepaidPopupPassword: "",
    isSharePopup: false,
    selectedPackage: "",

  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  componentDidMount() {
    this.getAccountData("");
    //this.handleUserSettings();
  }

  getAccountData = (api) => {
    let { show, accountHeader } = this.state;
    this.props
      .getCommonApi(`prepaidacclist/?cust_id=${this.props.id}${api}`)
      .then((key) => {
        console.log(key.data, "prepaid table list");
        let { data, header_data } = key;
        let { accountList } = this.state;
        accountList = data;
        accountHeader = header_data;
        this.setState({ accountList, accountHeader });
      });
    console.log(accountHeader, "sasasasasa");
  };

  handleChange = async (type) => {
    let { show } = this.state;
    show = type;
    await this.setState({
      show,
    });
    if (type === "all") {
      this.getAccountData("&is_all=1");
    } else {
      this.getAccountData("");
    }
  };
  handleUserSettings = () => {
    let { customerDisplayFlag } = this.state;
    this.props.getCommonApi(`userlist/`).then((key) => {
      let { status, data } = key;
      if (status === 200) {
        customerDisplayFlag = data.flgcustomer;
        this.setState({ customerDisplayFlag });
      }
    });
  };

  handleChangeExpiryDate = async ({ target: { value, name } }) => {
    let { editExpiryDate } = this.state;
    if (name === "editExpiryDate") {
      editExpiryDate = value;
      this.setState({
        editExpiryDate,
      });
    }
  };
  handleConfirm = () => {
    let data = {
      expiry_date: dateFormat(
        new Date(this.state.editExpiryDate),
        "yyyy-mm-dd"
      ),
      prepaid_id: this.state.editPrepaidId,
    };

    this.props
      .commonCreateApi(`prepaidacclist/changeexpirydate/`, data)
      .then((key) => {
        this.setState({ isOpenExpiryDate: false });
        Toast({
          type: "success",
          message: "Expiry date updated Successfully",
        });
        this.getAccountData("");
      });
  };

  handleOpenDetail = async (data) => {
    let { activeTab } = this.state;
    activeTab = "detail";

    await this.setState({
      activeTab,
    });
    this.getDetailList(data.id);
  };
  handleExpiryDate = async (data) => {
    let { isOpenExpiryDate, editExpiryDate, editPrepaidId } = this.state;
    isOpenExpiryDate = true;
    editExpiryDate = data.exp_date;
    editPrepaidId = data.id;
    this.setState({
      isOpenExpiryDate,
      editExpiryDate,
      editPrepaidId,
    });
  };
  handleTerminatePrepaid = async (data) => {
    let { isOpenTerminatePrepaid, terminatePrepaidPrepaidId } = this.state;
    isOpenTerminatePrepaid = true;
    terminatePrepaidPrepaidId = data.id;
    this.setState({
      isOpenTerminatePrepaid,
      terminatePrepaidPrepaidId,
    });
  };
  handleTerminatePrepaidDialog = async () => {
    let { isOpenTerminatePrepaid } = this.state;
    isOpenTerminatePrepaid = false;
    await this.setState({
      isOpenTerminatePrepaid,
    });
  };
  handleTerminatePrepaidSubmit = () => {
    let data = {
      username: this.state.prepaidPopupUserName,
      password: this.state.prepaidPopupPassword,
      prepaid_id: this.state.terminatePrepaidPrepaidId,
    };
    this.props
      .commonCreateApi(`prepaidacclist/terminateprepaid/`, data)
      .then((key) => {
        this.setState({ isOpenTerminatePrepaid: false });
        Toast({
          type: "success",
          message: "Terminated Prepaid Successfully",
        });
        this.getAccountData("");
      });
  };
  handleDialog = async () => {
    let { isOpenExpiryDate } = this.state;
    isOpenExpiryDate = false;
    await this.setState({
      isOpenExpiryDate,
    });
    //this.getCart();
  };
  getDetailList = (id) => {
    this.props.getCommonApi(`prepaidacclist/${id}/`).then((key) => {
      let { data, header_data } = key;
      let { DetailList, accountHeader } = this.state;
      DetailList = data;
      accountHeader = header_data;
      this.setState({ DetailList, accountHeader });
    });
  };

  handleBack = () => {
    let { activeTab } = this.state;
    activeTab = "";
    this.setState({
      activeTab,
      DetailList: [],
    });

    this.getAccountData("");
  };
  handlePrintPdfFormat = (url) => {
    this.setState({
      isPrintPdfClick: false,
    });
    var a = document.createElement("a");
    a.setAttribute("download", `${new Date()}.pdf`);
    a.setAttribute("href", url);
    a.click();
    window.open(url);
  };

  handleShareDialog = () => {
    this.setState({
      isSharePopup: false,
    });
  };

  handleShareIcon = (item) => {
    let sharePackage = {
      id: item?.itemcart_id,
      item_desc: item?.pp_desc,
      cust_noid: Number(this.props.id),
      shareId: item?.id,
    };
    this.setState({
      selectedPackage: sharePackage,
      isSharePopup: true,
    });
  };

  render() {
    let {
      treatmentList,
      headerDetails,
      accountList = [],
      show,
      accountHeader = {},
      activeTab,
      detailHeader,
      DetailList,
      isPrintPdfClick,
      isOpenExpiryDate,
      isOpenTerminatePrepaid,
      editExpiryDate,
      customerDisplayFlag,
      isSharePopup,
      selectedPackage,
    } = this.state;
    let {
      balance_producttype,
      balance_servicetype,
      balance_alltype,
      totalprepaid_count,
      pp_no,
    } = accountHeader;
    let { t } = this.props;
    return (
      <div className="treatment-account row">
        <div className="col-6 mt-3 mb-4">
          {activeTab !== "detail" ? (
            <div className="row">
              <div className="col-5 mb-2">{t("Total Prepaid Count")}</div>
              <div className="col-5 mb-2">{totalprepaid_count}</div>
              <div className="row m-0">
                <div className="col-12 mb-2">
                  <FormGroup check>
                    <Label check>
                      <Input
                        checked={show === "active"}
                        onChange={() => this.handleChange("active")}
                        type="radio"
                        name="radio1"
                      />
                      {t("Show active prepaid only")}
                    </Label>
                  </FormGroup>
                </div>
                <div className="col-12">
                  <FormGroup check>
                    <Label check>
                      <Input
                        checked={show === "all"}
                        onChange={() => this.handleChange("all")}
                        type="radio"
                        name="radio1"
                      />
                      {t("Show all prepaid")}
                    </Label>
                  </FormGroup>
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-2 mb-2">{t("PP_no")}</div>
              <div className="col-8 mb-2">{pp_no}</div>
            </div>
          )}
        </div>
        <div className="col-6 mt-3 mb-4">
          <div className="row">
            <div className="col-6 mb-2">{t("Balance of Product Type")}</div>
            <div className="col-6 mb-2">$ {balance_producttype}</div>

            <div className="col-6">{t("Balance of Service Type")}</div>
            <div className="col-6">$ {balance_servicetype}</div>

            <div className="col-6">{t("Balance of All Types")}</div>
            <div className="col-6">$ {balance_alltype}</div>
          </div>
        </div>
        <div className="col-12 prepaidAccountTableScroll">
          <div className="table">
            {activeTab !== "detail" ? (
              <TableWrapper
                headerDetails={headerDetails}
                queryHandler={this.handlePagination}
                // pageMeta={pageMeta}
                // isEmpty={accountList.length === 0 ? true:false}
              >
                {accountList && accountList.length > 0
                  ? accountList.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <div className="d-flex align-items-center justify-content-center">
                              <NormalButton
                                buttonClass={"view "}
                                mainbg={true}
                                className="col-12 fs-15 "
                                label="view"
                                onClick={() => this.handleOpenDetail(item)}
                              />
                            </div>
                          </td>
                          {item?.status === true && (
                            <td>
                              <NormalButton
                                buttonClass={"view "}
                                mainbg={true}
                                className="col-12 fs-15 "
                                label="Terminate Prepaid"
                                onClick={() =>
                                  this.handleTerminatePrepaid(item)
                                }
                              />
                            </td>
                          )}
                          <td>
                            <div
                              className={`d-flex align-items-center justify-content-center`}
                            >
                              <img
                                src={shareIcon}
                                className="share-icon"
                                onClick={() => this.handleShareIcon(item)}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="text-left">{item.sa_date}</div>
                          </td>
                          <td>
                            <div className="text-left">{item.prepaid}</div>
                          </td>
                          <td>
                            <div className="text-left">{item.pp_no}</div>
                          </td>
                          <td>
                            <div className="text-left">{item.pp_desc}</div>
                          </td>
                          <td>
                            <div className="text-right">{item.last_update}</div>
                          </td>

                          <td>
                            <div className="text-left">
                              {item.conditiontype1}
                            </div>
                          </td>
                          <td>
                            <div
                              className="text-right cursor-pointer"
                              onClick={() => this.handleExpiryDate(item)}
                            >
                              {item.exp_date}
                            </div>
                          </td>
                          <td>
                            <div className="text-left">{item.exp_status}</div>
                          </td>
                          <td>
                            <div className="text-right">{item.pp_total}</div>
                          </td>
                          <td>
                            <div className="text-right">
                              {"$" + item.remain}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  : null}
              </TableWrapper>
            ) : (
              <TableWrapper
                headerDetails={detailHeader}
                queryHandler={this.handlePagination}
              >
                {console.log(accountHeader, "accountheaderviewdetail")}
                {DetailList && DetailList.length > 0
                  ? DetailList.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <div className="text-left">{item.sa_date}</div>
                          </td>
                          <td>
                            <div className="text-left">{item.prepaid_ref}</div>
                          </td>
                          <td>
                            <div className="text-left">
                              {item.transaction_ref}
                            </div>
                          </td>
                          <td>
                            <div className="text-left">{item.status}</div>
                          </td>
                          {/* <td>
                            <div className="text-left">{item.voucher}</div>
                          </td> */}
                          {/* <td>
                            <div className="text-left">{item.item_no}</div>
                          </td> */}
                          <td>
                            <div className="text-left">{item.item_name}</div>
                          </td>
                          <td>
                            <div className="text-left">
                              {"$" + item.topup_amt}
                            </div>
                          </td>
                          <td>
                            <div className="text-left">
                              {"$" + item.use_amt}
                            </div>
                          </td>

                          <td>
                            <div className="text-left">
                              {"$" + item.balance}
                            </div>
                          </td>
                          {/* <td>
                            <div className="text-right">{item.topup_no}</div>
                          </td> */}
                        </tr>
                      );
                    })
                  : null}
              </TableWrapper>
            )}
          </div>
        </div>
        <div className="col-12 d-flex justify-center">
          {activeTab === "detail" ? (
            <NormalButton
              buttonClass={"back mr-3"}
              mainbg={true}
              className="col-12 fs-15 "
              label="Back"
              onClick={() => this.handleBack()}
            />
          ) : (
            ""
          )}
          <NormalButton
            buttonClass={"print"}
            // mainbg={true}
            className="col-12 fs-15 "
            label="Print"
            // outline={false}
            onClick={() => this.setState({ isPrintPdfClick: true })}
          />
        </div>
        <NormalModal
          className={"transaction-expiry-modal"}
          style={{ minWidth: "30%" }}
          modal={isOpenExpiryDate}
          handleModal={this.handleDialog}
        >
          <div className="d-flex justify-content-between">
            <div className="heading">
              <h5> Extend Expiry Date </h5>
            </div>

            <div>
              <img
                onClick={() => this.setState({ isOpenExpiryDate: false })}
                className="close"
                src={closeIcon}
                alt=""
              />
            </div>
          </div>
          <div>
            <div className="content">
              <div className="d-flex mt-4">
                <div className="col-6">
                  <NormalDate
                    value={new Date(editExpiryDate)}
                    name="editExpiryDate"
                    type="date"
                    minDate={new Date()}
                    onChange={this.handleChangeExpiryDate}
                  />
                </div>
                <div className="col-6">
                  <NormalButton
                    applybg={true}
                    label="Update"
                    onClick={() => this.handleConfirm()}
                  />
                </div>
              </div>
            </div>
          </div>
        </NormalModal>

        <NormalModal
          className={"transaction-done-modal"}
          style={{ minWidth: "30%" }}
          modal={isOpenTerminatePrepaid}
          handleModal={this.handleTerminatePrepaidDialog}
        >
          <div className="d-flex justify-content-between">
            <div className="heading">
              <h5> Terminate Prepaid</h5>
            </div>

            <div>
              <img
                onClick={() => this.setState({ isOpenTerminatePrepaid: false })}
                className="close"
                src={closeIcon}
                alt=""
              />
            </div>
          </div>
          <div>
            <div className="content">
              <div className="row">
                <div className="col-6">
                  <label>UserName </label>
                  <NormalInput
                    value={this.state.prepaidPopupUserName}
                    name="prepaidPopupUserName"
                    onChange={(e) =>
                      this.setState({ prepaidPopupUserName: e.target.value })
                    }
                  />
                </div>
                <div className="col-6">
                  <label>Paswword </label>
                  <NormalInput
                    type="password"
                    value={this.state.prepaidPopupPassword}
                    name="prepaidPopupPassword"
                    onChange={(e) =>
                      this.setState({ prepaidPopupPassword: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-2"></div>
                <div className="col-5">
                  <NormalButton
                    label="Cancel"
                    onClick={() =>
                      this.setState({ isOpenTerminatePrepaid: false })
                    }
                  />
                </div>
                <div className="col-5">
                  <NormalButton
                    applybg={true}
                    label="Proceed"
                    onClick={() => this.handleTerminatePrepaidSubmit()}
                  />
                </div>
              </div>
            </div>
          </div>
        </NormalModal>

        <NormalModal
          className={"edit-cart-modal"}
          style={{ minWidth: "75%" }}
          modal={isSharePopup}
          handleModal={this.handleShareDialog}
        >
          <img
            onClick={this.handleShareDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <ShareModal
            selectedPackage={selectedPackage}
            handleClose={this.handleShareDialog}
          />
        </NormalModal>

        {isPrintPdfClick ? (
          <PDFDownloadLink
            document={
              <Invoice
                TableList={activeTab !== "detail" ? accountList : DetailList}
                accountHeader={accountHeader}
                Flag={activeTab !== "detail" ? 3 : 4}
                landscape={true}
              />
            }
          >
            {({ blob, url, loading, error }) =>
              !loading && url ? this.handlePrintPdfFormat(url) : null
            }
          </PDFDownloadLink>
        ) : null}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      updateForm,
      commonCreateApi,
      commonPatchApi,
      commonDeleteApi,
    },
    dispatch
  );
};

export const PrepaidAccount = withTranslation()(
  connect(null, mapDispatchToProps)(PrepaidAccountClass)
);
